@if (message() || isOwner()) {
  <div class="mb-4 rounded-md border border-hairline bg-panel p-6">
    <div class="flex items-center justify-between">
      <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Message</h2>
      @if (isOwner() && !editing()) {
        <button
          type="button"
          (click)="start()"
          class="text-xs text-dusk hover:text-parchment hover:underline"
        >
          Edit
        </button>
      }
    </div>
    @if (editing()) {
      <textarea
        [formControl]="control"
        rows="3"
        placeholder="A note to your contestants — rules clarifications, prize info, etc."
        class="mt-3 w-full rounded border border-hairline bg-ink px-3 py-2 text-sm text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
      ></textarea>
      <div class="mt-2 flex items-center gap-3">
        <button
          type="button"
          (click)="save()"
          [disabled]="saving()"
          class="text-xs font-semibold text-gold hover:underline disabled:cursor-not-allowed disabled:opacity-50"
        >
          {{ saving() ? 'Saving…' : 'Save' }}
        </button>
        <button type="button" (click)="cancel()" class="text-xs text-dusk hover:text-parchment">
          Cancel
        </button>
      </div>
      @if (error()) {
        <p class="mt-2 rounded border border-wax/40 bg-wax/10 px-3 py-2 text-xs text-parchment">
          {{ error() }}
        </p>
      }
    } @else if (message()) {
      <p class="mt-3 whitespace-pre-wrap text-sm text-parchment">{{ message() }}</p>
    } @else {
      <p class="mt-3 text-sm text-dusk">No message set yet.</p>
    }
  </div>
}
